export const BRIEFCASE_FILTER_MY = 'my';
